import {Input} from 'antd'
import React from 'react'

const DecoratedInputField = ({ label, ...props }) => (
    <div className="flex flex-col px-3 py-2 border border-color-50 background rounded-lg hover:shadow-xs">
        <div className="text-xs text-color-300 italic tracking-wide">
            {label}
        </div>
        <Input {...props} />
    </div>
)

export default DecoratedInputField
